module.exports = __webpack_public_path__ + "static/media/mw-image2.1bd38ab3.PNG";